import axiosInstance from "../../utils/axiosInstance";

// loading
import {
  setService,
  setServices,
  setLoading,
} from "../../store/slices/service";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import { notify } from "../../components/alerts";
import { IApiResponse } from "../../store/@types/api-response";
import { IService, IServiceResponseData } from "../../store/@types/service";

const serviceEndpoint = "/product/api/v1/services";

export const get_services = async (
  dispatch: AppDispatch,
  limit: number = 20,
  offset: number = 0,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<
      IApiResponse<IServiceResponseData>
    >(`${serviceEndpoint}`, {
      params: { limit, offset },
    });
    dispatch(setServices(response.data));
  } catch (err) {
    if (isAxiosError(err)) {
      notify({
        type: "error",
        message: err.response?.data?.message || "Failed to load services.",
      });
    } else {
      throw err;
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_service = async (dispatch: AppDispatch, id: number) => {
  dispatch(setService(null));
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<IApiResponse<IService>>(
      `${serviceEndpoint}/${id}`,
    );
    dispatch(setService(response.data.data));
  } catch (err) {
    if (isAxiosError(err)) {
      notify({
        type: "error",
        message: err.response?.data?.message || "Failed to load service.",
      });
    } else {
      throw err;
    }
  } finally {
    dispatch(setLoading(false));
  }
};
